/**
 * Client factory
 */

import type { Client, ClientConfig, Interceptor } from './types';
import { InterceptorManager } from './interceptor';
import { createHTTPClient } from './http';
import { createWSConnection } from './ws';
import { createSSEStream } from './sse';

/**
 * Create API client
 * @param config Client configuration
 * @returns Client instance
 */
export function createClient(config: ClientConfig): Client {
  const interceptorManager = new InterceptorManager();

  // Create HTTP client
  const http = createHTTPClient(config, interceptorManager);

  return {
    http,

    ws(path) {
      return createWSConnection(path, config);
    },

    sse(path) {
      return createSSEStream(path, config);
    },

    use(interceptor: Interceptor) {
      return interceptorManager.add(interceptor);
    },
  };
}
